const datas = [
   {
      picUrl: '/assets/project-1.png',
      name: 'Person type website',
      describe: 'This is a website about personal characteristics.'
   },
   {
      picUrl: '/assets/flutter-pic.jpeg',
      name: 'Flutter basic interface',
      describe: 'This is a website that uses Flutter for the basic interface.'
   },
   {
      picUrl: '/assets/sc-auto-pic.png',
      name: 'SC Auto Car Hatyai',
      describe: 'This project is a scheduling and booking system for appointments to view cars.'
   },
   {
      picUrl: '/assets/culture-app-pic.png',
      name: 'Thailand Culture Website',
      describe: 'Here is a travel recommendation project for each region of Thailand.'
   },
]

export default datas;